import { render, staticRenderFns } from "./PrestaShop.vue?vue&type=template&id=71a42166"
import script from "./PrestaShop.vue?vue&type=script&lang=ts"
export * from "./PrestaShop.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports